import { Box, Skeleton } from '@mui/material';

const BucketCardSkeleton = () => (
	<div className="relative flex flex-col mt-16">
		{/* Green activated banner area */}
		<div className="absolute -top-16 left-0 right-0 h-[268px] bg-gray-100 rounded-3xl" />

		{/* Card body */}
		<div className="flex flex-col flex-1 relative z-10 rounded-3xl bg-gray-100" style={{ padding: '37px 45px 63px 37px' }}>
			{/* Title */}
			<Skeleton variant="text" sx={{ fontSize: '2rem', width: '75%' }} />
			<Skeleton variant="text" sx={{ fontSize: '2rem', width: '55%' }} />

			{/* ROI row */}
			<div className="border-t border-gray-300 mt-5 pt-4">
				<Skeleton variant="text" sx={{ fontSize: '0.875rem', width: '60%' }} />
			</div>

			{/* Description paragraphs */}
			<div className="border-t border-gray-300 mt-4 pt-5 flex flex-col gap-5">
				<div>
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '100%' }} />
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '80%' }} />
				</div>
				<div>
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '100%' }} />
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '70%' }} />
				</div>
				<div>
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '100%' }} />
					<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '60%' }} />
				</div>
			</div>

			{/* Action button */}
			<div className="mt-auto pt-8">
				<Skeleton variant="rounded" sx={{ borderRadius: '9999px', height: '48px', width: '100%' }} />
				<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '90%', mt: 1 }} />
			</div>
		</div>
	</div>
);

export const AutoInvestLoader = () => {
	return (
		<Box>
			{/* 3-column hero grid */}
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
				{/* Left intro panel */}
				<div className="bg-investor-bg rounded-2xl p-8 lg:p-10 flex flex-col justify-between mt-16">
					<div className="flex flex-col gap-3">
						<Skeleton variant="text" sx={{ fontSize: '2.25rem', width: '90%', bgcolor: 'rgba(255,255,255,0.1)' }} />
						<Skeleton variant="text" sx={{ fontSize: '2.25rem', width: '70%', bgcolor: 'rgba(255,255,255,0.1)' }} />
						<Skeleton variant="text" sx={{ fontSize: '2.25rem', width: '80%', bgcolor: 'rgba(255,255,255,0.1)' }} />
					</div>
					<div className="mt-8 flex justify-end">
						<Skeleton variant="circular" sx={{ width: 128, height: 128, bgcolor: 'rgba(255,255,255,0.1)' }} />
					</div>
				</div>

				{/* Two bucket card skeletons */}
				<BucketCardSkeleton />
				<BucketCardSkeleton />
			</div>

			{/* Become Pro section skeleton */}
			<div className="mt-6 bg-white rounded-2xl p-4">
				<div className="flex items-center gap-4">
					<Skeleton variant="text" sx={{ fontSize: '0.875rem', width: '60%' }} />
					<Skeleton variant="rounded" sx={{ borderRadius: '9999px', height: '36px', width: '120px', flexShrink: 0 }} />
				</div>
			</div>

			{/* Footer disclaimer skeleton */}
			<Skeleton variant="text" sx={{ fontSize: '0.75rem', width: '50%', mt: 2 }} />
		</Box>
	);
};
